import { Box, ButtonBase, Grid, Stack, styled, Typography } from '@mui/material';
import { ReactComponent as GoogleLogo } from '../../assets/svg/google_logo.svg';
import { ReactComponent as Logo } from '../../assets/svg/tenantport-lockup.svg';
import { useAuth0 } from '@auth0/auth0-react';
import tokens from '../../shared/theme/tokens';
import { IMAGES } from '../../shared/constant/image';
import { useTranslation } from 'react-i18next';

const SignInButton = styled(ButtonBase)(() => ({
  padding: '1rem 1.25rem',
  borderRadius: `${tokens.radius.sm}px`,
  border: `1px solid ${tokens.colors.borderStrong}`,
  backgroundColor: tokens.colors.surface,
  width: '100%',
  maxWidth: '26rem',
  fontSize: '1rem',
  lineHeight: 1.5,
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  gap: '.625rem',
  '&:hover': {
    backgroundColor: tokens.colors.hover,
  },
}));

export default function Login() {
  const { loginWithRedirect } = useAuth0();
  const { t } = useTranslation();

  const handleSignin = async () => {
    // Return to the URL the user originally requested (set by PrivateRouteProvider
    // as ?returnTo=...), falling back to the dashboard.
    const returnTo = new URLSearchParams(window.location.search).get('returnTo') || '/dashboard';
    await loginWithRedirect({
      authorizationParams: {
        responseType: 'code',
        redirectUri: `${window.location.origin}`,
        mode: 'login',
      },
      appState: {
        returnTo,
      },
    });
  };

  return (
    <Box sx={{ height: '100vh' }}>
      <Grid container sx={{ height: '100%' }}>
        <Grid item xs={6} sx={{ height: '100%', px: 4, backgroundColor: tokens.colors.pageBg }}>
          <Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
            <Logo style={{ height: 40 }} />
            <Typography variant="h2" sx={{ textAlign: 'center', mb: '3.25rem', mt: 3 }}>
              {t('landing.title')}
            </Typography>
            <SignInButton onClick={handleSignin}>
              <GoogleLogo /> {t('landing.signin')}
            </SignInButton>
          </Stack>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            height: '100%',
            borderLeft: `1px solid ${tokens.colors.border}`,
            backgroundImage: `url(${IMAGES.LANDING})`,
            backgroundSize: 'cover',
          }}
        />
      </Grid>
    </Box>
  );
}
